import ModelFactory from 'business/models/ModelFactory';
import { LicenseClient, LicenseDetailDTO } from 'business/models/Models';
import { FmlxBanner, FmlxButton, FmlxCard, FmlxTable } from 'fmlx-common-ui';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LicenseStyle.scss';
import DateHelper from 'utils/DateHelper';

const licenseClient: LicenseClient = ModelFactory(LicenseClient, false, true);

const columns = [
  { Header: 'Edition', accessor: 'edition', hideSort: true },
  { Header: 'Username', accessor: 'userName', hideSort: true },
  { Header: 'Platform', accessor: 'platform', hideSort: true },
  { Header: 'Last Activity', accessor: 'lastActive', hideSort: true },
];

export default function SessionTermination() {
  const [licenseDetail, setLicenseDetail] = useState<LicenseDetailDTO | null>(null);
  const navigate = useNavigate();

  async function fetchLicenseInfo() {
    const licenseDetailDto = await licenseClient.getLicenseDetail(false);

    if (
      licenseDetailDto.concurrentSessionList?.length &&
      licenseDetailDto.concurrentSessionList.findIndex(
        (session) => session.isLoggedUser,
      ) >= 0
    ) {
      // handle if the user is already in session
      navigate('/');
    }

    updateLicenseDataInState(licenseDetailDto);
  }

  useEffect(() => {
    fetchLicenseInfo();
  }, []);

  function updateLicenseDataInState(licenseDetailDto: LicenseDetailDTO) {
    if (!licenseDetailDto) {
      return;
    }
    if (
      licenseDetailDto.maxSessionsAllowed >
      (licenseDetailDto.concurrentSessionList?.length ?? 0)
    ) {
      navigate('/');
    }
    setLicenseDetail(licenseDetailDto);
  }

  function getActiveConcurrentSessions() {
    const cList = licenseDetail.concurrentSessionList ?? [];
    return cList.map((cl) => ({
      edition: licenseDetail.edition,
      userName: cl.userName,
      platform: cl.platform,
      lastActive: DateHelper.formatDateTime(cl.sessionStartTime),
    }));
  }

  const cancelClick = () => {
    navigate('/logout');
  };

  return (
    licenseDetail && (
      <div id="session-termination-wrapper">
        <FmlxCard
          id="session-termination-card"
          disabled={false}
          draggable={false}
          selectable={false}
          selected={false}
          type=""
          variant={FmlxCard.Variant.OUTLINED}
        >
          <FmlxCard.Body id="session-termination-card-body-wrapper">
            <h5 id="session-termination-card-body-label" className="label-primary mb-3">
              Active Session
            </h5>
            <div id="session-termination-card-body" className="body pt-5 px-5 pb-2">
              <FmlxBanner
                id="session-termination-card-body-banner"
                variant={FmlxBanner.Variant.INFO}
                hideCloseButton
                title={`
                Rock Maker is currently running at the maximum limit of ${licenseDetail.maxSessionsAllowed} locations,
                as per your agreement. Please contact the appropriate user to release a session.`}
              />
              <div
                id="session-termination-card-body-table"
                className="pt-5 session-list-container"
              >
                <FmlxTable
                  columns={columns as any}
                  data={getActiveConcurrentSessions()}
                  allowSelectedRow={false}
                />
              </div>
            </div>
          </FmlxCard.Body>
          <FmlxCard.Footer>
            <div
              id="session-termination-card-footer-wrapper"
              className="px-5 mr-4 mb-5 content-right-align"
            >
              <FmlxButton
                id="session-termination-card-footer-cancel-button"
                label="CANCEL"
                variant={FmlxButton.Variant.OUTLINE}
                onClick={cancelClick}
              />
            </div>
          </FmlxCard.Footer>
        </FmlxCard>
      </div>
    )
  );
}
